import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CredentialService {
  constructor(private http: HttpClient) { }


  saveComanies(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.COMPANIES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANIES, {...payload, signup:payload.id})
      .pipe(catchError(errorHandl));

  }

  getCompanies(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES, { params })
      .pipe(catchError(errorHandl));
  }

  getPicker(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

  getCompanyById(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  updateCompnayInformation(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.CREDENTIAL_COMPANIES + `/${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  // DRIVERS
  saveDrivers(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.DRIVERS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.DRIVERS, payload)
      .pipe(catchError(errorHandl));

  }

  getCompanyDrivers(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }

  getDriverById(id: any) {
    return this.http.get(urls.API_URL + urls.DRIVERS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getDriverVerification(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `${id}`)
      .pipe(catchError(errorHandl));
  }

  updateDriverVerification(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.COMPANY_DRIVERS + `${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  // Vehicles

  // DRIVERS
  saveVehicle(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.VEHICLES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.VEHICLES, payload)
      .pipe(catchError(errorHandl));

  }

  // getCompanyDrivers(id: any, queryParams:any) {
  //   const params = new HttpParams({fromObject: queryParams});
  //   return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `/${id}`, {params})
  //     .pipe(catchError(errorHandl));
  // }

  getVehicles(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_VEHICLES + `/${id}`, {params})
      .pipe(catchError(errorHandl));
  }

  getVehicleById(id: any) {
    return this.http.get(urls.API_URL + urls.VEHICLES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getVehicleVerification(id: any) {
    return this.http.get(urls.API_URL + urls.CREDENTIAL_VEHICLES + `${id}`)
      .pipe(catchError(errorHandl));
  }

  updateVehicleVerification(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.CREDENTIAL_VEHICLES + `${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  // Fare
  saveFare(id:any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.FARES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.FARES, payload)
      .pipe(catchError(errorHandl));

  }

  getFareById(id: any) {
    return this.http.get(urls.API_URL + urls.FARES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getCompanyFares(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_FARRES + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }
  getfundingSourceFares(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.FUNDING_SOURCE_FARRES + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }
  getFareEstimation(payload: any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS + '/' + urls.FARE_ESTIMATION,payload)
      .pipe(catchError(errorHandl));
  }

  getDashboardThresholds(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.THRESHOLDS_COMPANY + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }

  getThresholds(payload: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.THRESHOLDS_COMPANY + `/${payload.company}/status`  , { params })
      .pipe(catchError(errorHandl));
  }

  getCompanyThreshold(payload: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.THRESHOLDS_COMPANY + `/${payload.company}/status`  , { params })
      .pipe(catchError(errorHandl));
  }

}
